import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { Orgstyle } from './model/orgstyle';
import { SessionHelper } from '../sessionHelper';
import { DynamicstyleService } from './service/dynamicstyle.service';
import { UieventhubService } from '../uieventhub/uieventhub.service';
import { Subscription } from 'rxjs';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-dynamicstyle',
  templateUrl: './dynamicstyle.component.html',
  styleUrls: ['./dynamicstyle.component.css']
})
export class DynamicstyleComponent implements OnInit, OnChanges {
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  whitelabel:boolean;
  orgstyle:Orgstyle;
  footertextcolor:string;
  @Input() orgId:string;
  currentOrg:Subscription;
  currentOrgId:string;
  

  constructor(
    private dssrv:DynamicstyleService,
    private uievent:UieventhubService) { 
      this.currentOrg = this.uievent.currentOrg$.pipe(untilDestroyed(this)).subscribe(org => {
        this.currentOrgId = org;
        this.updateStylesSettings(org);
      })

    }
  ngOnChanges(changes:SimpleChanges){
    if(changes.orgId && changes.orgId.currentValue){
      this.updateStylesSettings(changes.orgId.currentValue);
    }
  }

  updateStylesSettings(orgId:string){
    this.isWhiteLabled();
    
    if(this.whitelabel){
      if(SessionHelper.getDynamicStyle() && SessionHelper.getDynamicStyle() !== 'undefined'  && JSON.parse(SessionHelper.getDynamicStyle()).organizationId === orgId){
        this.orgstyle = JSON.parse(SessionHelper.getDynamicStyle());
        this.setStyles();
      }else{
        this.dssrv.getOrgstyles(orgId).pipe(untilDestroyed(this)).subscribe(list => {
          this.orgstyle = list[0];
          if (!this.orgstyle) { return; }
          SessionHelper.setDynamicStyle(JSON.stringify(this.orgstyle));
          this.uievent.setDynamicStyle(this.orgstyle);
          this.setStyles();
        });

      }
    }else{
      this.dssrv.getDefaultOrgStyle().pipe(untilDestroyed(this)).subscribe(style =>{
        this.orgstyle = style;
        SessionHelper.setDynamicStyle(JSON.stringify(this.orgstyle));
        this.uievent.setDynamicStyle(this.orgstyle);
        this.setStyles();
      });
    }
  }

  ngOnInit() {
    this.footertextcolor = 'green';

    this.orgstyle = new Orgstyle;
    this.whitelabel = false;
    
    this.isWhiteLabled();
    
    if(this.whitelabel){
      if(SessionHelper.getDynamicStyle() && SessionHelper.getDynamicStyle() !== 'undefined'  && JSON.parse(SessionHelper.getDynamicStyle()).organizationId === this.orgId){
        this.orgstyle = JSON.parse(SessionHelper.getDynamicStyle());
        this.setStyles();
      }else{
        this.dssrv.getOrgstyles(SessionHelper.getChoosenOrg()).pipe(untilDestroyed(this)).subscribe(list => {
          this.orgstyle = list[0];
          if (!this.orgstyle) { return; }
          SessionHelper.setDynamicStyle(JSON.stringify(this.orgstyle));
          this.uievent.setDynamicStyle(this.orgstyle);
          this.setStyles();
        });
      }
    }else{
      this.dssrv.getDefaultOrgStyle().pipe(untilDestroyed(this)).subscribe(style =>{
        this.orgstyle = style;
        SessionHelper.setDynamicStyle(JSON.stringify(this.orgstyle));
        this.uievent.setDynamicStyle(this.orgstyle);
        this.setStyles();
      });
    }
  }
  setStyles(){
    this.favIcon.href = this.orgstyle.orgfavicon;
    SessionHelper.setTaskAnimation(this.orgstyle.taskanimation);
    //OrgColorSettings
    var bodyStyles = document.body.style;

    //task option settings
    bodyStyles.setProperty('--portal-mytask-task-bgcolor', this.orgstyle.taskmytaskbg );
    bodyStyles.setProperty('--portal-donetask-task-bgcolor', this.orgstyle.taskdonebg );
    bodyStyles.setProperty('--portal-customer-task-bgcolor', this.orgstyle.taskcustomerbg );
    bodyStyles.setProperty('--task-text-color', this.orgstyle.tasktextcolor );
    bodyStyles.setProperty('--portal-vendor-task-bgcolor', this.orgstyle.taskvendorbg );

    //Nav Control settings
    bodyStyles.setProperty('--top-nav-menu-weight', this.orgstyle.topnavnmenuweight );
    bodyStyles.setProperty('--top-nav-menu-weight-active', this.orgstyle.topnavmenuweightactive);
    bodyStyles.setProperty('--top-nav-menu-font', this.orgstyle.topnavmenufont );
    bodyStyles.setProperty('--top-nav-menu-size', this.orgstyle.topnavmenusize );
    bodyStyles.setProperty('--top-nav-icon-bg', this.orgstyle.topnavmenuiconbg );
    bodyStyles.setProperty('--top-nav-icon-bg-hover', this.orgstyle.topnavmenuiconbghover );
    bodyStyles.setProperty('--top-nav-icon-color', this.orgstyle.topnavmenuiconcolor );
    bodyStyles.setProperty('--top-nav-icon-color-hover', this.orgstyle.topnavmenuiconcolorhover );
    bodyStyles.setProperty('--top-nav-border-bottom', this.orgstyle.topnavnmenuborderbottom );

    //Page title settings
    bodyStyles.setProperty('--page-title-font', this.orgstyle.pagetitlefont );
    bodyStyles.setProperty('--page-title-weight', this.orgstyle.pagetitleweight );
    bodyStyles.setProperty('--page-title-color', this.orgstyle.pagetitlecolor );
    bodyStyles.setProperty('--page-title-size', this.orgstyle.pagetitlesize );
    bodyStyles.setProperty('--page-title-sub-font', this.orgstyle.pagetitlesubfont );
    bodyStyles.setProperty('--page-title-sub-weight', this.orgstyle.pagetitlesubweight );
    bodyStyles.setProperty('--page-title-sub-color', this.orgstyle.pagetitlesubcolor );
    bodyStyles.setProperty('--page-title-sub-size', this.orgstyle.pagetitlesubsize );

    //Portal icon settings
    bodyStyles.setProperty('--portal-icon-color', this.orgstyle.portaliconcolor );
    bodyStyles.setProperty('--portal-icon-color-hover', this.orgstyle.portaliconcolorhover );
    bodyStyles.setProperty('--portal-icon-bg', this.orgstyle.portaliconbg );
    bodyStyles.setProperty('--portal-icon-bg-hover', this.orgstyle.portaliconbghover );

    //Animation settings
    bodyStyles.setProperty('--task-animation', this.orgstyle.taskanimation );

    //Bottom nav settings
    bodyStyles.setProperty('--footer-nav-icon-color', this.orgstyle.footernaviconcolor );
    bodyStyles.setProperty('--footer-nav-icon-color-hover', this.orgstyle.footernaviconcolorhover );
    bodyStyles.setProperty('--footer-nav-icon-bg', this.orgstyle.footernaviconbg );
    bodyStyles.setProperty('--footer-nav-icon-bg-hover', this.orgstyle.footernaviconbghover );

    
    //infobox bg color
    bodyStyles.setProperty('--info-pin-bgcolor', this.orgstyle.infopinbgcolor );
    //infobox bg hover color
    bodyStyles.setProperty('--info-pin-hover-bgcolor', this.orgstyle.infopinhoverbgcolor );
    //customerpagelabelcolor
    bodyStyles.setProperty('--customerpage-label-color', this.orgstyle.customerpagelabelcolor );
    //planningNaviColor
        bodyStyles.setProperty('--planner-navi-bg-hover', this.orgstyle.plannerdaycolor );
        bodyStyles.setProperty('--planner-navi-color', this.orgstyle.plannerdaycolor );
        //table text color
        bodyStyles.setProperty('--planner-content-color', this.orgstyle.plannerdaycolor );

        bodyStyles.setProperty('--planner-content-color', this.orgstyle.tabletextcolor );
    //OrgLogoSwitch
    bodyStyles.setProperty('--top-nav-logo-display', this.orgstyle.logoformat == "square" || this.orgstyle.logoformat == "squareandtitle" ? "inline-block" : "none");
    bodyStyles.setProperty('--top-nav-logo-long-display', this.orgstyle.logoformat === "rectangel" ? "inline-block" : "none");

    //orgbrandswitch
    bodyStyles.setProperty('--top-nav-brand-display', this.orgstyle.logoformat == "squareandtitle" ? "inline-block" : "none");

    //OrgBrandWeight
    bodyStyles.setProperty('--top-nav-brand-weight', this.orgstyle.orgBrandWeight );

    //ButtonTextColor
    bodyStyles.setProperty('--button-text-color', this.orgstyle.buttontextColor );

    //ButtonbgHoverColor
    bodyStyles.setProperty('--button-text-color-hover', this.orgstyle.buttontextHoverColor );

    //iconcolor
    bodyStyles.setProperty('--material-icon-color-actions', this.orgstyle.orgiconColor );
    bodyStyles.setProperty('--material-icon-color', this.orgstyle.orgiconColor );

    //iconhovercolor
    bodyStyles.setProperty('--material-icon-color-hover', this.orgstyle.orgiconhoverColor );

    //notification-counter-border-color
    bodyStyles.setProperty('--notification-counter-border-color', this.orgstyle.orgiconColor );

    //login
    bodyStyles.setProperty('(--login-top-bgcolor', this.orgstyle.mainColor );

    //helpericoncolor
    bodyStyles.setProperty('--brand-color', this.orgstyle.mainColor );

 
    //orgheadercolor
    bodyStyles.setProperty('--header-text-color', this.orgstyle.orgFontColor );
    //orgtextcolor
    bodyStyles.setProperty('--info-pin-text-color', this.orgstyle.orgFontColor );
    bodyStyles.setProperty('--content-text-color', this.orgstyle.orgFontColor );
    //modalheader
    bodyStyles.setProperty('--modal-header-color', this.orgstyle.orgtitlecolor );
    //BUTTON COLORS
    //buttoncolor
    bodyStyles.setProperty('--button-bg-color', this.orgstyle.buttonbgcolor );
    //buttonhovercollor
    bodyStyles.setProperty('--button-bg-color-hover', this.orgstyle.buttonbghovercolor );
    //notificationdesccolor
    bodyStyles.setProperty('--notification-desc-color', this.orgstyle.orgFontColor );
    //notificationheadercolor
    bodyStyles.setProperty('--notification-text-color-title', this.orgstyle.orgFontColor );
    //footerbgcolor
    bodyStyles.setProperty('--footer-bgcolor', this.orgstyle.mainColor );
    //loadercolor
    bodyStyles.setProperty('--loader-color', this.orgstyle.mainColor );
    //notification
    bodyStyles.setProperty('--notification-list-header-text-color', this.orgstyle.orgFontColor );
    //orgactioncolor
    bodyStyles.setProperty('--notification-counter-bgcolor', this.orgstyle.mainColor );
  //NEGATIVE TO THE MAIN COLOR
     //usericoncolor
     bodyStyles.setProperty('--top-nav-active-menucolor', this.orgstyle.negMainColor );
      //tabledhoverlistcolor
      bodyStyles.setProperty('--table-hover-text-color', this.orgstyle.mainColor );
      //notificationCounterColor
      bodyStyles.setProperty('--notification-counter-text-color', this.orgstyle.negMainColor);
      //topnavlinkcolor
      bodyStyles.setProperty('--top-nav-link-color', this.orgstyle.negMainColor);
  //END TO NEGATIVE TO THE MAIN COLOR
      //progressbarcolor
      bodyStyles.setProperty('--progressbar-bgcolor', this.orgstyle.mainColor );
      bodyStyles.setProperty('--progressbar-0-textcolor', this.orgstyle.mainColor );
      //orgmaincolor
      bodyStyles.setProperty('--top-nav-bgcolor', this.orgstyle.mainColor );


      //modalheader
      bodyStyles.setProperty('--modal-header-color', this.orgstyle.orgFontColor );
      //notificationdesccolor
      bodyStyles.setProperty('--notification-desc-color', this.orgstyle.orgFontColor );
      //notificationheadercolor
      bodyStyles.setProperty('--notification-text-color-title', this.orgstyle.orgFontColor );
      //footerbgcolor
      bodyStyles.setProperty('--footer-bgcolor', this.orgstyle.mainColor );
      //loadercolor
      bodyStyles.setProperty('--loader-color', this.orgstyle.mainColor );
     
      //progressbarcolor
      bodyStyles.setProperty('--progressbar-bgcolor', this.orgstyle.mainColor );
      bodyStyles.setProperty('--progressbar-0-textcolor', this.orgstyle.mainColor );
      //orgmaincolor
      bodyStyles.setProperty('--top-nav-bgcolor', this.orgstyle.mainColor );
    //NEGATIVE TO MAIN COLOR
      bodyStyles.setProperty('--notification-counter-text-color', this.orgstyle.negMainColor);
    //END TO NEGATIVE TO MAIN COLOR
    //ORG MAIN COLOR END

    //topnav and footer border
    bodyStyles.setProperty('--footer-top-border', this.orgstyle.navborder);
    
    //ORGTITLE COLOR
    bodyStyles.setProperty('--active-org-color', this.orgstyle.orgtitlecolor);
    //FOOTER TEXT COLOR
    bodyStyles.setProperty('--footer-text-color', this.orgstyle.footertextcolor);


    //ORG BORDERRADIUS
      //orgborderradius
      bodyStyles.setProperty('--progressbar-border-radius', this.orgstyle.borderRad );
      bodyStyles.setProperty('--customerportal-button-border-radius', this.orgstyle.borderRad );
      bodyStyles.setProperty('--customerportal-border-radius', this.orgstyle.borderRad );
      bodyStyles.setProperty('--border-radius', this.orgstyle.borderRad );
      bodyStyles.setProperty('--button-border-radius', this.orgstyle.borderRad );
      bodyStyles.setProperty('--comment-border-radius', this.orgstyle.borderRad );
    //ORG BORDERRADIUS END

    //ORG FONT
      //orgfontheader
      bodyStyles.setProperty('--font-brand', this.orgstyle.orgFont );
      //orgfontcontent
      bodyStyles.setProperty('--header-font', this.orgstyle.orgFont );
      bodyStyles.setProperty('--comment-font', this.orgstyle.orgContentFont );
      bodyStyles.setProperty('--button-font', this.orgstyle.orgContentFont );
      bodyStyles.setProperty('--planner-font', this.orgstyle.orgContentFont );
      bodyStyles.setProperty('--comment-font', this.orgstyle.orgContentFont );
      bodyStyles.setProperty('--font', this.orgstyle.orgContentFont );
      bodyStyles.setProperty('--footer-font', this.orgstyle.orgContentFont );
      bodyStyles.setProperty('--content-font', this.orgstyle.orgContentFont );
    //ORG FONT END
  }
  isWhiteLabled(){
   //console.log('DynamicstyleComponent: isWhiteLabled called');
   //console.log('DynamicstyleComponent: SessionHelper.getPersonOrgs():', SessionHelper.getPersonOrgs());
   //console.log('DynamicstyleComponent: SessionHelper.getChoosenOrg():', SessionHelper.getChoosenOrg());
   //console.log('DynamicstyleComponent: this.orgId:', this.orgId);
    
   // if(!SessionHelper.getCustomer()){
      function isCurrent(org) {
        return org.organizationId == SessionHelper.getChoosenOrg();
      }
      if(SessionHelper.getPersonOrgs()){
        let orgs = [];
        let org;
        if(Array.isArray(JSON.parse(SessionHelper.getPersonOrgs())) && JSON.parse(SessionHelper.getPersonOrgs()).length > 0){
          orgs = JSON.parse(SessionHelper.getPersonOrgs());
          org = orgs.find(isCurrent);
        }else{
          org = JSON.parse(SessionHelper.getPersonOrgs());
        }
      
       //console.log('DynamicstyleComponent: found org:', org);
        if(org && org.modules){
         //console.log('DynamicstyleComponent: org modules:', org.modules);
          if(org.modules.indexOf('whitelabel')>=0) {
            this.whitelabel = true;
          }else{
            this.whitelabel = false;
          }
        } else {
         //console.log('DynamicstyleComponent: no modules found, defaulting to false');
          this.whitelabel = false;
        }
      }else{
        this.whitelabel = false;
      }
      // }else{
      //   this.whitelabel = false;
      // }
      
    }
    
}
